import React, { useCallback } from 'react'
import { InspectorLayersTreeNode } from '../types'
import { useFindLayerNodeFromCanvasRelativePositionInScreenSpace } from '../useFindLayerNodeFromCanvasRelativePositionInScreenSpace'
import { findPointRelativeToCanvasInScreenSpaceFromMouseEvent } from './findPointRelativeToCanvasInScreenSpaceFromMouseEvent'

/**
 * Hook creating the handler for the click event on the canvas.
 */
export function useCanvasClickHandler(
  inspectorLayersTreeRootNode: InspectorLayersTreeNode | null,
  onClick: (node: InspectorLayersTreeNode | null) => void,
  doesLayerNodeAllowUserInteraction?: (
    node: InspectorLayersTreeNode,
    event: React.MouseEvent<HTMLElement>
  ) => boolean
) {
  const findTargetLayerFromCanvasRelativePositionInScreen = useFindLayerNodeFromCanvasRelativePositionInScreenSpace(
    inspectorLayersTreeRootNode
  )

  const clickHandler = useCallback(
    (reactEvent: React.MouseEvent<HTMLElement>) => {
      const pointRelativeToCanvasInScreenSpace = findPointRelativeToCanvasInScreenSpaceFromMouseEvent(
        reactEvent
      )

      if (!pointRelativeToCanvasInScreenSpace) {
        return null
      }

      const matchingNode = findTargetLayerFromCanvasRelativePositionInScreen(
        pointRelativeToCanvasInScreenSpace,
        node => doesLayerNodeAllowUserInteraction?.(node, reactEvent) ?? true
      )
      onClick(matchingNode)
    },
    [
      doesLayerNodeAllowUserInteraction,
      findTargetLayerFromCanvasRelativePositionInScreen,
      onClick,
    ]
  )

  return clickHandler
}
